import {connectWrapper} from '../Poll';
import AgendaPoll from './component';

export default connectWrapper(AgendaPoll);



// WEBPACK FOOTER //
// ./src/component/molecules/AgendaPoll/index.js